import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import api from 'modules/queries/api';
import {
	type LWApiPublicCloudBackupListParamsRawI,
	type LWApiPublicCloudBackupListResultRawI,
} from '@liquidweb-dev/club-sauce/public/cloud/backup/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';

const sortBackups = (data: LWApiPublicCloudBackupListResultRawI) =>
	[...data.items].sort(
		(a, b) =>
			new Date(b.time_taken).getTime() - new Date(a.time_taken).getTime(),
	);

export const CLOUD_BACKUP_LIST_QUERY_KEY = '/cloud/backup/list';

const useCloudBackupList = (
	params: LWApiPublicCloudBackupListParamsRawI,
	options?: UseQueryOptions<LWApiPublicCloudBackupListResultRawI, ApiErrorI>,
) =>
	useQuery({
		queryKey: [CLOUD_BACKUP_LIST_QUERY_KEY, params],
		queryFn: () => api.cloud.backup.apiRaw.list(params),
		...options,
	});

export const useAllCloudBackups = (
	params: LWApiPublicCloudBackupListParamsRawI,
	options?: UseQueryOptions<
		LWApiPublicCloudBackupListResultRawI,
		ApiErrorI,
		LWApiPublicCloudBackupListResultRawI['items']
	>,
) =>
	useQuery({
		queryKey: [CLOUD_BACKUP_LIST_QUERY_KEY, { page_size: 9999, ...params }],
		queryFn: () => api.cloud.backup.apiRaw.list(params),
		select: sortBackups,
		...options,
	});

export default useCloudBackupList;
